// extracted by mini-css-extract-plugin
module.exports = {"menu":"Navbar_menu__1WwBM","avatar":"Navbar_avatar__1OzkO","bottomLogo":"Navbar_bottomLogo__23370"};